import { api } from '../services/api';
import { setMoneyDefaults } from './formatMoney';

/**
 * Load Admin market defaults (timezone / locale / currency) once at app start.
 * Safe to call without auth — uses public /api/common/localization.
 */
export async function hydrateLocalizationDefaults() {
  try {
    const data = await api.get('/api/common/localization');
    setMoneyDefaults({
      currency: data?.currency,
      locale: data?.locale,
      timezone: data?.timezone,
    });
    return data;
  } catch (err) {
    console.warn('Failed to hydrate localization defaults:', err?.message || err);
    return null;
  }
}
